<template>
  <div v-if="stateData.attachments.length">
    <p class="mb-1">Załączniki:</p>

    <ul>
      <template v-for="(attachment, index) of stateData.attachments">
        <li :key="'procedureAttachment_' + index">
          <div class="row">
            <div :class="hasSubAttachment(attachment) ? 'col-11' : 'col-12'">
              <post-form
                aria-label-text="Pobierz załącznik"
                button-class="mr-2 attachments__post-form"
                :text="attachment.name"
                :url="downloadLink(attachment)"
              />

              <div class="pl-5" style="font-size: 0.9em">
                {{ attachment.description }}
              </div>
            </div>

            <div v-if="hasSubAttachment(attachment)" class="col-1 text-right">
              <tooltip :text="tooltipDownloadContentText">
                <post-form
                  button-class="btn-icon btn-sm mr-2 btn-light"
                  icon="fal fa-fw fa-download"
                  :aria-label-text="tooltipDownloadContentText"
                  :url="downloadContentLink(attachment)"
                />
              </tooltip>
            </div>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PostForm from '@/components/postForm/PostForm';
import Tooltip from '@/components/tooltip/Tooltip';
import { EntityType } from '@/enums/entityType.enum';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/procedureAttachments.schema';
import { config } from '@/utils/config';

// @vuese
// Zakładka z załącznikami procedury
// @group Procedure
export default {
  components: { PostForm, Tooltip },
  mixins: [formMixin],
  schema,
  data() {
    return {
      config,
      entityType: EntityType.PROCEDURE,
      entityId: this.$route.params.procedureId.toString(),
      tooltipDownloadContentText: 'Pobierz zawartość załącznika',
      model: {}
    };
  },
  computed: {
    ...mapState({
      stateData: state => ({ attachments: state.procedure.attachment.list })
    })
  },

  mounted() {
    this.$schema.$setData(this.stateData);
  },
  methods: {
    // @vuese
    // Link do pobrania załącznika
    downloadLink(attachment) {
      return `${this.config.mediaURL}/${attachment.mediaId}`;
    },
    // @vuese
    // Link do pobrania zawartości załącznika
    downloadContentLink(attachment) {
      return `${this.config.mediaURL}/${attachment.metadata.content.mediaId}`;
    },
    // @vuese
    // Sprawdzanie czy załącznik ma zawartość
    hasSubAttachment(attachment) {
      return attachment.metadata && attachment.metadata.content && attachment.metadata.content.mediaId;
    }
  }
};
</script>
